import * as React from "react";
function SvgCheckboxFalse(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      ref={svgRef}
      {...props}
    >
      <rect
        width={16}
        height={16}
        x={1}
        y={1}
        fill="none"
        stroke="#e04684"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        rx={2}
        ry={2}
      />
      <path
        fill="none"
        stroke="#e04684"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 4l10 10"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCheckboxFalse);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
